import React, { useState } from 'react';

import { observer } from 'mobx-react-lite';
import { FileType, FileUploadTicketType } from 'stores/file_store';
import useStores from 'hooks/useStores';


type FileContextType = {

    // Fetch and get one
    fetchFile: (identity: string, uuid: string) => Promise<FileType | null>;
    fetchFileByUuid: (identity: string, uuid: string) => Promise<FileType | null>;
    getFile: (uuid: string) => FileType | null;

    // // Fetch and get list by identity
    // fetchListByIdentityFile: (identity_uuid: string, cursor: string) => Promise<FileType[]>;
    // getListByIdentityFile: (identity_uuid: string) => FileType[];

    getUploadTicket: (identity: string) => Promise<FileUploadTicketType | null>;
    createWithTicket: (identity: string, ticket: string, filename: string, content_type: string) => Promise<FileType | null>;

    getDownloadUrl: (identity: string, file: string, disposition: string) => Promise<string | null>;
    fetchThumbnailUrl: (identity: string, file: string, disposition?: string) => Promise<string | null>;
    fetchThumbnailUrlByOwner: (identity: string, owner: string, disposition?: string) => Promise<string | null>;

    // Contains all known File items
    items: FileType[];
}

export const FileContext = React.createContext<FileContextType>({

    fetchFile: () => { throw 'Not Implemented' },
    fetchFileByUuid: () => { throw 'Not Implemented' },
    getFile: () => { throw 'Not Implemented' },
    // fetchListByIdentityFile: () => { throw 'Not Implemented' },
    // getListByIdentityFile: () => { throw 'Not Implemented' },
    getUploadTicket: () => { throw 'Not Implemented' },
    createWithTicket: () => { throw 'Not Implemented' },
    getDownloadUrl: () => { throw 'Not Implemented' },
    fetchThumbnailUrl: () => { throw 'Not Implemented' },
    fetchThumbnailUrlByOwner: () => { throw 'Not Implemented' },
    items: [] as FileType[],
});




export const FileProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [items, setItems] = useState([] as FileType[]);
    const { fileStore } = useStores();

    // const addItems = (newItems: FileType[] | FileType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setFile([...items, ...newItems]);
    // };

    const fetchFile = async (identity: string, association_uuid: string) => {
        // Autogenerated
        return fileStore.fetchFile(identity, association_uuid);
    };

    const getFile = (file_uuid: string) => {
        return fileStore.items.find((item) => item.uuid === file_uuid) || null;
    };

    const fetchFileByUuid = async (identity: string, uuid: string) => {
        return fileStore.fetchFileByUuid(identity, uuid);
    };

    // const getListByIdentityFile = (identity_uuid: string) => {
    //     // Autogenerated
    //     return items.slice().filter((item) => item.identity === identity_uuid);
    // };

    const createWithTicket = async (identity: string, ticket: string, filename: string, content_type: string) => {
        return fileStore.createWithTicket(identity, ticket, filename, content_type)
            .then((file: FileType | null) => {
                if(file) {
                    setItems([...items, file]);
                }
                return file;
            });
    };

    const getUploadTicket = async (identity: string) => {
        console.log('getUploadTicket', identity);
        return fileStore.getUploadTicket(identity);
    };



    const data = {
        fetchFile,
        fetchFileByUuid,
        getFile,
        getDownloadUrl: fileStore.getDownloadUrl,
        fetchThumbnailUrl: fileStore.fetchThumbnailUrl,
        fetchThumbnailUrlByOwner: fileStore.fetchThumbnailUrlByOwner,
        // fetchListByIdentityFile,
        // getListByIdentityFile,
        getUploadTicket,
        createWithTicket,
        items,
    };

    return (
        <FileContext.Provider value={data}>{ children }</FileContext.Provider>
    );

});
